// extracted by mini-css-extract-plugin
module.exports = {"row":"styles-module__row___Eudsr","col":"styles-module__col___o9sKd","map":"styles-module__map___PwGNQ","submit":"styles-module__submit___sx7JP"};